<template>
    <el-drawer title="添加课程体系" :visible.sync="show" :wrapperClosable="false" direction="rtl" :size="size"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="currentTab">
                <el-tab-pane label="添加课程体系" name="addOne">
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="体系名称">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="编程语言">
                            <el-select v-model="form.type" placeholder="编程语言" :disabled="form.id>0">
                                <el-option v-for="item in lessonTypes" :key="item.optionValue" :label="item.optionText"
                                    :value="item.optionValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="体系类型">
                            <el-select v-model="form.useType" clearable placeholder="编程语类型言">
                                <el-option label="通用体系" :value="1"></el-option>
                                <el-option label="充值体系" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="标签">
                            <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>
                        </el-form-item>
                        <el-form-item label="适用范围">
                            <el-input v-model="form.suitCrowd"></el-input>
                        </el-form-item>
                        <el-form-item label="封面">
                            <el-upload class="photo_uploader" action="" :show-file-list="false"
                                :before-upload="uploadCover">
                                <img v-if="form.coverImg != null" :src="form.coverImg" class="avatar">
                                <i v-else class="el-icon-plus uploader-icon"></i>
                            </el-upload>

                        </el-form-item>
                        <el-form-item label="简介">
                            <el-input type="textarea" placeholder="请输入内容" v-model="form.introduction" maxlength="255"
                                :rows="5" show-word-limit>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>


               <!-- <el-tab-pane label="从总部体系库导入111" name="addBatch">
                    <div class="fx-g1" v-loading="showLoading" element-loading-text="数据处理中，请稍后...">
                        <el-form ref="form" :model="form2" label-width="80px" class="edit_form">
                            <el-form-item label="关键词">
                                <el-input v-model="form2.keywords" suffix-icon="el-icon-search"
                                    style="width: 340px;margin-right: 20px"></el-input>
                            </el-form-item>
                        </el-form>

                        <el-table :data="centerSystemList" stripe style="width: 100%"
                            @selection-change="handleLessonChoose">
                            <el-table-column type="selection" :selectable="selectable" width="55">
                            </el-table-column>
                            <el-table-column width="160" label="封面">
                                <template slot-scope="scope">
                                    <el-image style="width: 150px; height: 90px" :src="scope.row.coverImg"
                                        :preview-src-list="[scope.row.coverImg]" fit="fill"></el-image>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="180" prop="name" label="系列课名称">
                            </el-table-column>

                            <el-table-column prop="typeName" min-width="120" label="类型">
                            </el-table-column>
                            <el-table-column width="120" prop="useTypeName" label="体系类型">
                            </el-table-column> -->
                            <!-- <el-table-column
                                min-width="120"
                                label="适用版本" >
                                <template slot-scope="scope">
                                    <div class="fx-col fx-center">
                                        <span v-for="(item,i) in scope.row.versionNameArray" :key="i">
                                            {{item}}
                                        </span>
                                    </div>
                                </template>
                            </el-table-column> -->
                     <!--       <el-table-column prop="lessonCount" min-width="120" label="课程数">
                            </el-table-column>
                            <el-table-column min-width="200" label="标签">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.tagArray" size="mini"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="240">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="previewSystem(scope.row)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane -->
                <el-tab-pane :key="item.name" v-for="(item) in previewTabs" :label="item.title" :name="item.name">
                    <component :is="item.page" :attr="item.attr" class="fx-g1"></component>
                </el-tab-pane>
            </el-tabs>
        </div>
        <span class="fx fx-center">
            <el-button v-if="currentTab=='addOne'" type="primary" @click="subOne()">添 加</el-button>
            <el-button v-else type="primary" @click="subBatch()" :disabled="subDisabled">添 加</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>
    export default {
        props: [],
        data() {
            return {
                show: false,
                currentTab: "addOne",
                needRefreshParent: false,


                form: {
                    ...this.item
                },
                lessonTypes: [],

                showLoading: false,
                form2: {},
                choosedLesson: [],
                centerSystems: [],

                previewTabs: [],
                subDisabled: false,
            }

        },
        computed: {
            size() {
                return this.currentTab == "addOne" ? "700px" : "80%"
            },
            centerSystemList() {
                return this.form2.keywords ? this.centerSystems.filter(item => {
                    return (item =>
                        (item.name ? item.name.indexOf(this.form2.keywords) > -1 : false) ||
                        (item.sn ? item.sn.indexOf(this.form2.keywords) > -1 : false) ||
                        (Array.isArray(item.tags) && item.tags.indexOf(this.form2.keywords) > -1)
                    )(item);
                }) : this.centerSystems;

            }
        },
        watch: {},
        methods: {
            uploadCover(file) {
                this.$uploadQiniu(file, "lessonsystem/", {
                    success: (file) => {
                        this.form = Object.assign({}, this.form, {
                            coverImg: file.url
                        });
                    }
                })

                return false;
            },
            subOne() {
                this.$ajaxPost("/lessonSystem/save", {
                    lessonSystem: this.form
                }, (data) => {
                    this.$emit("submit");
                })
            },
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            handleLessonChoose(val) {
                this.choosedLesson = val;
            },
            previewSystem(system) {
                this.previewTabs.push({
                    title: system.name,
                    name: "system" + system.id,
                    page: () => import("@/views/lesson/LessonSystemDetail"),
                    attr: {
                        lessonSystem: system,
                        isCenter: true,
                    }
                })
                this.currentTab = "system" + system.id;
            },
            loadCenterSystems() {
                this.$ajaxPost("/lessonSystem/listCenterSystems1", {
                    form: this.form2
                }, (data) => {
                    //这里改需求，不显示无权勾选的体系
                    this.centerSystems = data.result.filter(item => item.canChoose);
                    //this.centerSystems = data.result;
                })
            },
            selectable(row, index) {
                return row.canChoose;
            },
            subBatch() {
                this.subDisabled = true;
                this.showLoading = true;
                this.$ajaxPost("/lessonSystem/copyFromCenter", {
                    systemIds: this.choosedLesson.map(item => item.id)
                }, (data) => {
                    this.showLoading = false;
                    this.needRefreshParent = true;
                    this.subDisabled = false;
                    this.$showSuccess("保存成功");
                    this.$emit("submit", data.result);
                }, (data) => {
                    this.subDisabled = false;//重新勾选的时候,要把这个按钮重新变成可点击的
                    this.$showError(data.msg);
                    this.showLoading = false;
                })
            }
        },


        mounted() {
            this.show = true;
        },
        created() {
            this.loadLessonTypes();
            this.loadCenterSystems();
        }
    }
</script>
